import type {
  IOnboardingSubmitProfileParams,
  IOnboardingSubmitProfileBody,
  IOnboardingSubmitProfileRequest,
  IOnboardingSubmitProfileResponse,
} from '@/app-package';

import axios from 'axios';

const submitProfile = async (
  params: IOnboardingSubmitProfileParams,
  body: IOnboardingSubmitProfileBody,
) => {
  const url = `/onboarding/${params.claimHash}`;

  const config: IOnboardingSubmitProfileRequest = {
    url,
    method: 'post',
    data: body,
  };

  const { data } =
    await axios.request<IOnboardingSubmitProfileResponse>(config);

  return data;
};

export default submitProfile;
